import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_WikiRoleGuide = _resolveComponent("WikiRoleGuide")!
  const _component_TopRolePlayer = _resolveComponent("TopRolePlayer")!
  const _component_LocalizedTextWrapper = _resolveComponent("LocalizedTextWrapper")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "evil-loyalty-icon" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('brute.seoHeading')), 1)
    ]),
    _createVNode(_component_WikiRoleGuide, { role: "brute" }),
    _createVNode(_component_TopRolePlayer, {
      role: "brute",
      class: "my-4"
    }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('brute.generalTips')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('brute.earlyMissionFlexibility')), 1),
        _createVNode(_component_LocalizedTextWrapper, { keypath: "brute.earlyMissionFlexibilityDescription" })
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('brute.maintainUnpredictability')), 1),
        _createVNode(_component_LocalizedTextWrapper, { keypath: "brute.maintainUnpredictabilityDescription" })
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('brute.strategicSuccessLater')), 1),
        _createVNode(_component_LocalizedTextWrapper, { keypath: "brute.strategicSuccessLaterDescription" })
      ])
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}